"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmperorsSliceAbilityHandler = exports.EmperorsSliceActorAbilityFactory = exports.EmperorsSliceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Random_1 = require("../../utils/Random");
class EmperorsSliceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EmperorsSlice;
        this.__typeName = "EmperorsSlice";
    }
}
exports.EmperorsSliceAbilityArgs = EmperorsSliceAbilityArgs;
let EmperorsSliceActorAbilityFactory = class EmperorsSliceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EmperorsSlice", "AllEnemies", 0);
    }
};
EmperorsSliceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EmperorsSlice")
], EmperorsSliceActorAbilityFactory);
exports.EmperorsSliceActorAbilityFactory = EmperorsSliceActorAbilityFactory;
let EmperorsSliceAbilityHandler = class EmperorsSliceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: Array(2).fill(0).map(() => ({
                targetId: (0, Random_1.randomElement)(enemies),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 40)
                ]
            }))
        });
    }
};
EmperorsSliceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EmperorsSlice)
], EmperorsSliceAbilityHandler);
exports.EmperorsSliceAbilityHandler = EmperorsSliceAbilityHandler;
